import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class TranslateConfigService {
  constructor(private translate: TranslateService) {}

  getDefaultLanguage() {
    const language:any = this.translate.getBrowserLang();
    this.translate.setDefaultLang(language);
    return language;
  }

  setLanguage(setLang:any) {
    this.translate.use(setLang);
  }
  async getT(key:any) {
    // console.log(`this.translate.get(key);?`, this.translate.get(key));
    return await this.translate.instant(key);
  }
}
